import { SearchItem } from './module';

export interface VerticalSearchItemData {
  verticalName: string;
}
export const VerticalModuleId = 'Vertical' as const;
export const VerticalSearchItemVersion = '1' as const;
export interface VerticalSearchItem extends SearchItem<VerticalSearchItemData> {
  version: typeof VerticalSearchItemVersion;
  moduleId: typeof VerticalModuleId;
}
export const isVerticalSearchItem = (item: SearchItem): item is VerticalSearchItem =>
  item.moduleId === VerticalModuleId && item.version === VerticalSearchItemVersion;

export const createVerticalSearchItem = (verticalName: string) => ({
  data: {
    verticalName,
  },
  id: verticalName,
  moduleId: VerticalModuleId,
  version: VerticalSearchItemVersion,
});
